import type { InputHTMLAttributes } from 'react';

type AdminFormInputProps = {
  label: string;
  required?: boolean;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'className'>;

export default function AdminFormInput({ label, required, id, ...props }: AdminFormInputProps) {
  return (
    <label htmlFor={id} className="flex flex-col gap-2">
      <span className="flex items-center gap-2 text-sm font-bold text-main">
        {label}
        {required && (
          <span className="rounded-full bg-[#fff0f0] px-3 py-0.5 text-xs font-bold text-danger">
            必須
          </span>
        )}
      </span>
      <input
        id={id}
        className="box-border h-[42px] w-full min-w-0 rounded border border-solid border-border bg-white px-sm text-sm text-main"
        {...props}
      />
    </label>
  );
}
